import _test from "ramda/src/test";
import _identity from "ramda/src/identity";
import _ifElse from "ramda/src/ifElse";
import _useWith from "ramda/src/useWith";
import _assoc from "ramda/src/assoc";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _typeof from "@babel/runtime/helpers/typeof";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toPairs from "ramda/src/toPairs";
import _curry from "ramda/src/curry";
import _either from "ramda/src/either";
import { isArray, isObject } from "../../../browser/is";
import { mapDeep } from "../../../browser/object";

var isArrayOrObject = _either(isArray, isObject);

export var flattenKeysFrom = _curry(function (prefix, query) {
  return _toPairs(query).reduce(function (flat, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        val = _ref2[1];

    var flatKey = prefix ? "".concat(prefix, "[").concat(key, "]") : key;
    return _typeof(val) === 'object' ? _objectSpread({}, flat, flattenKeysFrom(flatKey, val)) : _assoc(flatKey, val, flat);
  }, {});
});
export var mapDeepWithArr = _useWith(mapDeep, [function (pred) {
  return _ifElse(isArrayOrObject, mapDeepWithArr(pred), pred);
}, _identity]);
export var couldBeValidNumber = _test(/^[0-9]+(\.[0-9]+)?$/);